import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { LogOut } from 'lucide-react'
import { useAuth } from '../context/AuthContext'
import { CHRISTMAS_SEASON_YEAR } from '../utils/christmasYear'

const Header: React.FC = () => {
  const { user, logout, allUsers, isUserDirectoryLoading } = useAuth()
  const location = useLocation()

  const wishlistTabs = React.useMemo(() => {
    const map = new Map<string, { id: string; label: string }>()

    const addTab = (identifier?: string | null, label?: string | null) => {
      if (!identifier) {
        return
      }

      map.set(identifier, {
        id: identifier,
        label: label?.trim() || identifier
      })
    }

    allUsers.forEach((profile) => {
      addTab(
        profile.id,
        profile.shortName
      )
    })

    return Array.from(map.values()).sort((a, b) => a.id.localeCompare(b.id))
  }, [allUsers])

  return (
    <header className="App-header">
      <div className="container">
        <div className="header-content">
          <Link to="/" className="logo">
            {`Christmas App ${CHRISTMAS_SEASON_YEAR}`}
          </Link>
          {user && (
            <div className="nav" style={{ alignItems: 'center', gap: '0.75rem' }}>
              <span style={{ fontSize: '0.9rem', color: '#fff' }}>
                Logged in as <b>{user.shortName}</b>
              </span>
              <button
                type="button"
                onClick={logout}
                className="btn btn-secondary"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.25rem',
                  padding: '0.4rem 0.75rem',
                  backgroundColor: '#5c6f63',
                  border: '1px solid #4a5a50'
                }}
              >
                <LogOut size={16} />
                Sign Out
              </button>
            </div>
          )}
        </div>
        <div
          className="nav"
          style={{ gap: '0.35rem', flexWrap: 'wrap', alignItems: 'center', marginTop: '0.75rem' }}
          role="tablist"
        >
          {isUserDirectoryLoading && (
            <span className="nav-link" style={{ opacity: 0.8 }}>
              Loading wish lists...
            </span>
          )}
          {!isUserDirectoryLoading && wishlistTabs.map((tab) => {
            const tabPath = `/wishlist/${tab.id}`
            const isActive = location.pathname === tabPath || location.pathname.startsWith(`${tabPath}/`)
            return (
              <Link
                key={tab.id}
                to={tabPath}
                className={`nav-link${isActive ? ' active' : ''}`}
                style={{
                  borderBottom: isActive ? '2px solid #fff' : '2px solid transparent',
                  borderRadius: '4px',
                  paddingBottom: '0.1rem'
                }}
                aria-current={isActive ? 'page' : undefined}
                role="tab"
              >
                {tab.label}
              </Link>
            )
          })}
        </div>
      </div>
    </header>
  )
}

export default Header